import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { labelXSmallSemiboldStyle as x, textMediumStyle as f, textXSmallRegularStyle as u } from "../Typography/internal.js";
const v = ({
  time: d,
  title: n,
  details: t,
  showDetails: i = !0,
  position: l = "Start",
  className: r = "",
  "data-cy": s
}) => {
  const c = /* @__PURE__ */ e(
    "div",
    {
      className: "flex items-center justify-center w-[11px] h-[11px] rounded-full shrink-0 bg-neutral_solid",
      "data-name": "Icon"
    }
  ), m = /* @__PURE__ */ e("div", { className: "w-full", "data-name": "Time", children: /* @__PURE__ */ e(
    "p",
    {
      className: `${x} text-foreground_faded leading-[16px]`,
      children: d
    }
  ) }), o = /* @__PURE__ */ a("div", { className: "w-full", "data-name": "Content", children: [
    /* @__PURE__ */ e("div", { className: "w-full", "data-name": "Title", children: /* @__PURE__ */ e(
      "p",
      {
        className: `${f} text-foreground leading-[24px]`,
        children: n
      }
    ) }),
    i && t && /* @__PURE__ */ e("div", { className: "w-full", "data-name": "Details", children: /* @__PURE__ */ e(
      "p",
      {
        className: `${u} text-foreground_faded leading-[16px]`,
        children: t
      }
    ) })
  ] });
  return /* @__PURE__ */ a(
    "div",
    {
      className: `relative w-full pb-6 ${r}`,
      "data-name": `Position=${l}`,
      "data-cy": s,
      children: [
        (l === "Middle" || l === "End") && /* @__PURE__ */ e(
          "div",
          {
            className: "absolute left-[5px] top-0 w-px h-[8px]",
            style: { backgroundColor: "var(--neutral_solid)" },
            "data-name": "Prefix line"
          }
        ),
        /* @__PURE__ */ a("div", { className: "flex flex-row gap-4 relative", children: [
          /* @__PURE__ */ e("div", { className: "flex items-start justify-center w-[11px] shrink-0 pt-[2.5px]", children: c }),
          /* @__PURE__ */ a("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ e("div", { children: m }),
            /* @__PURE__ */ e("div", { children: o })
          ] })
        ] }),
        (l === "Start" || l === "Middle") && /* @__PURE__ */ e(
          "div",
          {
            className: "absolute left-[5px] w-px",
            style: {
              backgroundColor: "var(--neutral_solid)",
              top: "11px",
              bottom: "0"
            },
            "data-name": "Suffix line"
          }
        )
      ]
    }
  );
};
export {
  v as TimelineElement
};
